// extracted by mini-css-extract-plugin
export default {"container":"tY-z","heading":"uY-z","links":"vY-z","copy":"wY-z","subCopy":"xY-z","linksLeft":"yY-z","linksCenter":"zY-z","linksRight":"AY-z","link":"BY-z","onlyLink":"CY-z"};